export default __webpack_public_path__ + "static/media/spark_32.83cc942f.png";